import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreModule } from '@core/core.module';

import { VrfLanSubnetsModule } from '@views/vrf-lan-subnets/vrf-lan-subnets.module';

import { VrfLanSubnetIPsDetailComponent } from './vrf-lan-subnet-ips-detail.component';
import { VrfLanSubnetIPsModalComponent } from './vrf-lan-subnet-ips-modal.component';


@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    VrfLanSubnetsModule,
  ],
  declarations: [
    VrfLanSubnetIPsDetailComponent,
    VrfLanSubnetIPsModalComponent,
  ],
  exports: [
    VrfLanSubnetIPsModalComponent,
  ],
})
export class VrfLanSubnetIPsModule {}
